import { render, staticRenderFns } from "./SalarySheetImport.vue?vue&type=template&id=6ff0ac90"
import script from "./SalarySheetImport.vue?vue&type=script&lang=js"
export * from "./SalarySheetImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports